export const RECEIPT_ALLOWED_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'application/pdf',
] as const;

export type ReceiptMimeType = (typeof RECEIPT_ALLOWED_MIME_TYPES)[number];

export const RECEIPT_UPLOAD_ACCEPT = RECEIPT_ALLOWED_MIME_TYPES.join(',');
